const { produce } = require("immer");

const init = {
  uid: null,
  pseudo: null,
  profileUid: null,
  groupUid: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_userForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.profile) draft.profileUid = action.form.profile;
        if(action.form.group) draft.groupUid = action.form.group;
      });

    case "UPDATE_userForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_userForm":
      return init;

    default:
      return state;
  }
}
